module.exports = __webpack_public_path__ + "img/drt10.f9e29535.png";